<template>
  <div>
    <PCNavbar selectIndex="12"/>
    <MobileNavBar :currentActive="11" />
    <supplyChainAudit/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import supplyChainAudit from '@/components/supply_chain_audit/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    supplyChainAudit
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>